<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <el-tabs v-model="activeTab" v-if="this.$hasPerm('Z005') || this.$hasPerm('Z016') || this.$hasPerm('Z019')">
          <el-tab-pane label="公司权限" name="permissionPool" v-if="this.$hasPerm('Z019')">
            <permissionPool/>
          </el-tab-pane>
          <el-tab-pane label="角色列表" name="roles" v-if="this.$hasPerm('Z016')">
            <role/>
          </el-tab-pane>
          <el-tab-pane label="权限管理" name="permission" v-if="this.$hasPerm('Z005')">
            <permission/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import permissionPool from './permissionPool';
import role from './role';
import permission from './permission';

export default {
  data() {
    return {
      activeTab: ''
    };
  },
  methods: {

  },
  components: {
    role, permission, permissionPool
  },
  mounted() {
    if (this.$hasPerm('Z019')) {
      this.activeTab = 'permissionPool';
    } else if (this.$hasPerm('Z016')) {
      this.activeTab = 'roles';
    } else if (this.$hasPerm('Z005')) {
      this.activeTab = 'permission';
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/permission/list.vue